/**
 * Created by ak on 05.11.2017.
 */

import parent from '../../wgg/wgg.module';
import './map.service';
import  '../map/mapOption.service'

export default class MapController{
    constructor($rootScope , $timeout, $q, $location, mapService, $scope) {
        "ngInject";

        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$location = $location;
        this.mapService = mapService;

        this.init();

        this.activeLayer = 'roadLayer';
        this.isTrafficLayerVisible = false;
        //this.showLayer(this.activeLayer);

    }

    init() {
        this.$rootScope.wgw = {
            destroyScopes: [],
            waitForPromises: []
        };

        this.mapService.loadLayer();

    };

    refreshPoiLayer() {
        let activePois = this.pois.filter(poi => poi.active);
        // pluck the id attrib
        let activeIds = activePois.map( ({ id }) => id );
        this.mapService.setActivePoiIds(activeIds);
        this.mapService.refreshPoiLayer();
    }

    showLayer(layer) {

        this.activeLayer = layer;

        if (layer === 'roadLayer') {
            this.mapService.showLayer('baseLayer');
            this.mapService.hideLayer('labelLayer');
            this.mapService.hideLayer('satelliteLayer');
            this.mapService.hideLayer('zoningLayer');
        }

        if (layer === 'satelliteLayer') {
            this.mapService.hideLayer('baseLayer');
            this.mapService.showLayer('labelLayer');
            this.mapService.showLayer('satelliteLayer');
            this.mapService.hideLayer('zoningLayer');
        }

        if (layer === 'zoningLayer') {
            this.mapService.showLayer('baseLayer');
            this.mapService.showLayer('labelLayer');
            this.mapService.hideLayer('satelliteLayer');
            this.mapService.showLayer('zoningLayer');
        }

    }

    toggleLayer(layer) {
        if (this.isTrafficLayerVisible) {
            this.mapService.hideLayer('transportLayer');
        }
        else {
            this.mapService.showLayer('transportLayer');
        }
        this.isTrafficLayerVisible = !this.isTrafficLayerVisible;
    }

    load() {
        this.mapService.addPostMessageListener();
    }



}






// WEBPACK FOOTER //
// ./src/components/map/map.controller.js